module.exports = __webpack_public_path__ + "img/redjik_logo.5f346130.png";